<script>
import { Page } from '@/api'
import PageFormBase from '@/crudBases/form/PageFormBase'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: PageFormBase,
  data() {
    return {
      livePreview: true,
      redirectRoute: { name: 'Pages List' },
      charsetsOptions: [
        {
          label: 'Russian',
          value: 'ru'
        },
        {
          label: 'Thai',
          value: 'th'
        },
        {
          label: 'Japanese',
          value: 'jp'
        },
        {
          label: 'Chinese',
          value: 'zh'
        },
        {
          label: 'Arabic',
          value: 'ar'
        }
      ]
    }
  },
  methods: {
    getGeneralFields() {
      return [
        new fields.Switch({
          label: 'Is home',
          modelPath: [this, 'form', 'is_home']
        }),
        new fields.Switch({
          label: 'Hide menu',
          modelPath: [this, 'form', 'is_menu_hidden']
        }),
        new fields.Input({
          label: 'Title',
          modelPath: [this, 'form', 'title'],
          multilingual: true
        }),
        new fields.Input({
          label: 'Big title',
          modelPath: [this, 'form', 'big_title'],
          multilingual: true
        }),
        new fields.Input({
          label: 'Big label',
          modelPath: [this, 'form', 'big_label'],
          multilingual: true
        }),
        new fields.Select({
          label: 'Special characters set',
          modelPath: [this, 'form', 'charset'],
          options: this.charsetsOptions
        }),
        new fields.ForeignKey({
          label: 'Parent',
          modelPath: [this, 'form', 'parent'],
          labelField: `title_${this.currentLanguage}`,
          valueField: 'id',
          clearable: true,
          required: false,
          disabled:
            get(this, ['form', 'is_home']) || get(this, ['form', 'has_child']),
          service: Page,
          serviceParams: this.getServiceParams()
        }),
        new fields.Link({
          label: 'FAQ link',
          modelPath: [this, 'form', 'faq_link']
        })
      ]
    },
    getServiceParams() {
      let params = { page_size: 'max' }
      if (this.$router.history.current.params.id) {
        params['id__not'] = this.$router.history.current.params.id
      }
      return params
    }
  },
  computed: {
    service() {
      return Page
    },
    currentLanguage() {
      return this.$store.state.selectedLanguage
    }
  }
}
</script>
